import React from "react";
import "./Policy.css";

const RefundTerms = () => {
  return (
    <div className="policy-page">

      {/* HERO SECTION */}
      <div className="policy-hero">
        <h1>Refund Terms & Conditions</h1>
        <p>
          Please read our refund policy carefully before purchasing any
          service. By availing our services, you agree to the terms and
          conditions mentioned below.
        </p>
      </div>

      <div className="policy-content">

        {/* SECTION 1 */}
        <div className="policy-section">
          <h2>₹300 Deduction on Every Service Refund</h2>

          <p>
            For every service refund request, a minimum administrative and
            processing charge of ₹300 (Rupees Three Hundred only) shall be
            deducted from the total amount paid by the customer.
          </p>
        </div>

        {/* SECTION 2 */}
        <div className="policy-section">
          <h2>Government Rejection or Delay</h2>

          <p>
            No refund shall be issued if E-Advisors Solution has processed the
            registration/application as per applicable government guidelines
            and the application is rejected, delayed, or kept pending by the
            concerned government department or officials.
          </p>
        </div>

        {/* SECTION 3 */}
        <div className="policy-section">
          <h2>Non-Submission of Documents or Non-Cooperation</h2>

          <p>
            Refunds may not be processed if the application cannot be completed
            due to:
          </p>

          <div className="policy-card">
            <ul>
              <li>Non-submission of required documents</li>
              <li>Incorrect information provided by the applicant</li>
              <li>Lack of response or cooperation from the customer</li>
              <li>
                Any other circumstance beyond our control preventing completion
                of the service
              </li>
            </ul>
          </div>
        </div>

        {/* SECTION 4 */}
        <div className="policy-section">
          <h2>Government Fees and Challans</h2>

          <p>
            Any government fee, duty, challan amount, or statutory payment paid
            during the registration or application process is non-refundable.
          </p>

          <div className="highlight-box">
            Government fees will only be charged after payment proof or challan
            receipt has been shared with the customer.
          </div>
        </div>

        {/* SECTION 5 */}
        <div className="policy-section">
          <h2> Complimentary Services or Discount Offers</h2>

          <p>
            No refund shall be issued if the customer has already availed any
            complimentary service, free offer, discount benefit, software
            subscription, promotional package, or advertisement service
            attached to the purchased service.
          </p>
        </div>

        {/* SECTION 6 */}
        <div className="policy-section">
          <h2> Subscription-Based Services</h2>

          <p>
            No refund shall be possible for subscription-based services such as:
          </p>

          <div className="policy-card">
            <ul>
              <li>GST return filing packages</li>
              <li>Company annual compliance packages</li>
              <li>Monthly or yearly compliance services</li>
            </ul>
          </div>

          <div className="highlight-box">
            Once the service has been partially processed or delivered.
          </div>
        </div>

        {/* SECTION 7 */}
        <div className="policy-section">
          <h2> Maximum Refund Amount</h2>

          <p>
            Under no circumstances shall the refund amount exceed the amount
            originally paid by the customer after deduction of applicable
            administrative, processing, and government charges.
          </p>
        </div>

      </div>
    </div>
  );
};

export default RefundTerms;